import { showToast } from "./toastController";
import type { PrototypeRuntime } from "./prototypeTypes";

export function recordRuntimeError(runtime: PrototypeRuntime, error: unknown) {
  runtime.lastApiError = error instanceof Error ? error.message : String(error);
}

/**
 * User-friendly validation failure. Replaces window.alert with a toast.
 * Returns false so call sites can early-return in validators.
 */
export function failValidation(message: string): false {
  showToast({ type: "warning", message });
  return false;
}

/**
 * Success/info toast bridge for non-validation flows.
 */
export function notifySuccess(message: string, title?: string): void {
  showToast({ type: "success", message, title });
}

export function notifyError(message: string, title?: string): void {
  showToast({ type: 'error', message, title });
}
